<template>
  <div>
    <b-card no-body class="border-0 p-1 rounded mb-0 text-center bk-color-transparent-1">
      <div  v-if="vuexLoading">
        <pulse-loader sm=12 class="text-center align-content-center align-items-center mt-2" color="#290A99"/>
      </div>
      <b-container v-else>
      <b-row v-if="isNoRanges" class="p-5">
        <b>Aún no tienes campañas activas. En tu suscripción actual tienes cupo para una campaña. Comunícate con tu ejecutivo para más información.</b>
      </b-row>
      <b-row v-else>
        <b-col
          sm="3"
          v-for="item in ranges"
          :key="item.id"
          class="pointer"
          :id="`popover-1-${item.name}`"
          @click="setSelectedOption(item)"
        >
        <MetricCard
          :name="item.name"
          :color="item.color"
          :arrow="item.arrow"
          :value="item.salesData.sales1"
          :border="item.id === selectedRangeCard ? 'primary' : 'light'"
        />
             <b-popover :target="`popover-1-${item.name}`" triggers="hover" placement="auto">
              <div>
                <p><b>{{item.name}}</b></p>
                <p>{{item.description}}</p>
                <p><b>Rangos del periodo:</b></p>
                <p>
                  Actual: {{item.actual_period.start_date}} al {{item.actual_period.end_date}}
                  <br>
                  Venta: {{ item.salesData.sales1_no_abb}}
                  <br>
                  <br>
                  Anterior: {{item.last_period.start_date}} al {{item.last_period.end_date}}
                  <br>
                  Venta: {{ item.salesData.sales2_no_abb}}
                </p>
                <h5 class="text-center">
                  {{item.salesData.var}}
                  <i :style="`color:${item.color}`" :class="item.arrow" aria-hidden="true"></i>
                </h5>
                <div class="text-center " v-if="selectedRangeCard !== item.id">
                  <b-button
                    variant="primary"
                    @click="setSelectedOption(item)"
                  >
                    Seleccionar
                  </b-button>
                </div>
              </div>
            </b-popover>
        </b-col>
      </b-row>
    </b-container>
    </b-card>
  </div>
</template>

<script>
  import { DimensionUtils, GeneralUtils } from '@/mixins/index'
  import MetricCard from '@/app/shared/components/MetricCard'
  import { BulletListLoader } from 'vue-content-loader'
  export default {
    name: 'MetricOpt',
    mixins: [GeneralUtils, DimensionUtils],
    components: {
      BulletListLoader,
      MetricCard
    },
    computed: {
      vuexAccumulatedSalesKpiData () {
        return this.$_generalUtils_deepJsonCopy(this.$store.state.sellOutDashboardCard.accumulatedSalesKpiData)
      },
      vuexLoading () {
        return this.$store.state.sellOutDashboardCard.loading
      },
      selectedRangeCard () {
        let selected = this.$_generalUtils_deepJsonCopy(this.$store.state.sellOutDashboardCard.selectedMetricOption)
        return selected['id']
      },
      campaignsRanges () {
        return this.vuexAccumulatedSalesKpiData.filter(accumulatedSalesKpiData => accumulatedSalesKpiData.is_campaign)
      },
      dynamicRanges () {
        return this.vuexAccumulatedSalesKpiData.filter(accumulatedSalesKpiData => !accumulatedSalesKpiData.is_campaign)
      },
      ranges () {
        return this.$store.state.selectedRangeOption === 'dynamicRanges' ? this.dynamicRanges : this.campaignsRanges
      },
      isNoRanges () {
        return this.ranges.length === 0
      },
    },
    methods: {
      setSelectedOption (item) {
        this.$store.commit('commit_selectedMetricOption', item.id)
        this.$store.commit('commit_sellOutDashboardCard_selectedMetricOption', item)
        this.$emit('change-dashboard-indicator', item)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/expertoRetail/components/SellOutAccumulatedMetricOpt/MetricOpt.vue